import { render, staticRenderFns } from "./NotaFiscalXmlBtn.vue?vue&type=template&id=751f7c32&"
import script from "./NotaFiscalXmlBtn.vue?vue&type=script&lang=js&"
export * from "./NotaFiscalXmlBtn.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
installComponents(component, {VBtn})
